// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import {
//   buildCourseDetailsURI,
//   buildCourseModalsURI,
// } from "../../../_helpers/utilities";
// import RenderRating from "../../Other/StarRating/RenderRating";
// import { getS3URL } from "../../../_helpers/utilities";
// import CartButton from "./CartButton/CartButton";
// import { deleteWishlist, addWishlist } from "../../../_actions/cart.actions";
// import { courseActions } from "../../../_actions";
// import CourseModal from "./CourseModal";
// import "tippy.js/themes/light.css";
// import "tippy.js/dist/tippy.css";
// import Tippy from "@tippyjs/react";
// import moment from "moment/moment";
// import "./ToolTip.scss";
// import { set } from "date-fns";

// const CourseTile = ({
//   post,
//   bundle,
//   demo,
//   hidedata,
//   viewType,
//   activeTab,
//   onClickTabItem,
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loggedIn } = useSelector((state) => state.authentication);
//   const { t } = useTranslation();
//   const [modal, setModal] = useState(false);
//   const likeHandler = (courseId, isWishlisted) => {
//     if (loggedIn && isWishlisted) {
//       dispatch(courseActions.handleResetCourseList());
//       dispatch(deleteWishlist(courseId));
//     } else if (loggedIn && !isWishlisted) {
//       dispatch(courseActions.handleResetCourseList());
//       dispatch(addWishlist(courseId));
//     } else {
//       navigate("/login");
//     }
//     // onClickTabItem(activeTab, courseId);
//   };

//   const handleModal = () => {
//     setModal(true);
//   };


//   const [screenSize, setScreenSize] = useState(getCurrentDimension());

//   function getCurrentDimension() {
//     return {
//       width: window.innerWidth,
//       height: window.innerHeight
//     };
//   }

//   useEffect(() => {
//     const updateDimension = () => {
//       setScreenSize(getCurrentDimension());
//     };
//     window.addEventListener("resize", updateDimension);


//     return (() => {
//       window.removeEventListener("resize", updateDimension);
//     });
//   }, [screenSize]);
//   //console.log("post",post);
//   return (
//     <>
//       <Tippy
//         theme="light"
//         className="tippy"
//         interactive={true}
//         flipBehavior="flip"
//         disabled={viewType === "list" ? false : screenSize.width < 525 ? true : false}
//         placement="right"
//         content={
//           <div className="tippy-content">
//             <div className="tippy-coursename">
//               {post.CourseName || post.name}
//             </div>
//             <div className="topspace">
//               <p className="updated-date">
//                 <div className="courseSellingStatus">Bestseller</div>
//                 <span> Updated:-</span>
//                 {!bundle
//                   ? moment(post?.CreatedOn).format("MMM DD, YYYY")
//                   : moment(post?.createdAt).format("MMM DD, YYYY")}
//               </p>
//             </div>
//             <div className="topspace">
//               <div>
//                 <span>
//                   {" "}
//                   <span className="checkMarkPreview">&#10003;</span>
//                   InstructorName :-
//                 </span>{" "}
//                 {post?.instructorName}
//               </div>
//               <div>
//                 <span>
//                   <span className="checkMarkPreview">&#10003;</span>Duration:-
//                 </span>
//                 {post.Duration || post.duration} Hours
//               </div>
//               <div>
//                 <span>
//                   <span className="checkMarkPreview">&#10003;</span>Language:-
//                 </span>
//                 {post.Language || " "}
//               </div>
//               <div>
//                 <span>
//                   <span className="checkMarkPreview">&#10003;</span>Level:-
//                 </span>
//                 {post.Level || " "}
//               </div>
//               <div>
//                 <span>
//                   <span className="checkMarkPreview">&#10003;</span>Price:-
//                 </span>
//                 ${post.EnrollmentFee || post.price}
//               </div>

//               <div className="oneliner">
//                 {bundle ? (
//                   <div
//                     dangerouslySetInnerHTML={
//                       post.description
//                         ? {
//                           __html:
//                             post.description
//                               .replace(/<img .*?>/g, "")
//                               .substring(0, 300) + "...",
//                         }
//                         : {
//                           __html: post.description,
//                         }
//                     }
//                   ></div>
//                 ) : (
//                   <div
//                     dangerouslySetInnerHTML={
//                       post.Description
//                         ? {
//                           __html:
//                             post.Description.replace(
//                               /<img .*?>/g,
//                               ""
//                             ).substring(0, 300) + "...",
//                         }
//                         : {
//                           __html: post.Description,
//                         }
//                     }
//                   ></div>
//                 )}
//               </div>
//             </div>
//             <div className="navigationPreview">
//               <Link
//                 to={
//                   !bundle
//                     ? buildCourseDetailsURI(
//                       post.category,
//                       post.CourseName,
//                       post.ID
//                     )
//                     : buildCourseDetailsURI("", post.name, post.id, post.id)
//                 }
//                 className="btn-edit-content startCourse"
//               >
//                 More Info
//               </Link>
//             </div>
//           </div>
//         }
//       >
//         {bundle ? (
//           <div className="post" key={demo ? post : post.id ? post.id.toString() : post.ID.toString()}>
//             <div className="image-wrapper">
//               {demo ? (
//                 <img src={post?.imageLink} alt="" />
//               ) : (
//                 <Link
//                   aria-label="Course Details"
//                   to={buildCourseDetailsURI("", post.name, post.ID, post.ID)}
//                 >
//                   <img
//                     src={post?.imageLink ? getS3URL(post.imageLink) : ""}
//                     alt=""
//                   />
//                 </Link>
//               )}
//             </div>

//             <div className="tile-content">
//               {demo ? (
//                 <div className="tile-header">{post?.name}</div>
//               ) : (
//                 <Link
//                   aria-label="Course Details"
//                   to={buildCourseDetailsURI("", post.name, post.ID, post.ID)}
//                 >
//                   <div className="tile-header">{post?.name}</div>
//                 </Link>
//               )}

//               <div className="container-wrap">
//                 <RenderRating ratings={Number(0)} />
//                 <div className="price-wrapper">
//                   <span
//                     className="price"
//                     style={post?.isPurchased ? { opacity: "0.5" } : null}
//                   >
//                     {post.price !== null ? `${post.price}   ` : null}
//                   </span>
//                 </div>
//               </div>

//               <div className="button-wrapper">
//                 <div className="">
//                   <Link
//                     to={
//                       demo
//                         ? ""
//                         : buildCourseDetailsURI("", post.name, post.ID, post.ID)
//                     }
//                   >
//                     <span>{t("moreInfo")}</span>
//                   </Link>
//                 </div>

//                 <div>
//                   <CartButton post={{ ...post, ID: post.ID }} bundle={bundle} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="post" key={post.ID.toString()}>
//             <div className="image-wrapper">
// {loggedIn && <div
//   className="icon-wrapper"
//   onClick={() => likeHandler(post.ID, post?.isWishlisted)}
// >
//   <span
//     className={`icon ${!post?.isWishlisted ? "icon-like" : "icon-liked"
//       } `}
//   ></span>
// </div>}
//               <Link
//                 to={{
//                   pathname: buildCourseDetailsURI(
//                     post.category,
//                     post.CourseName,
//                     post.ID
//                   ),
//                 }}
//               >
//                 <div
//                   className={`${post.category === null ? "category-null" : "category"
//                     }`}
//                 >
//                   {post.category}
//                 </div>

//                 <img
//                   src={
//                     post?.imageFiles?.length > 0
//                       ? getS3URL(post?.imageFiles[0]?.fileName)
//                       : post?.imageFiles
//                         ? getS3URL(post?.imageFiles?.fileName)
//                         : post.fileName
//                           ? getS3URL(post?.fileName)
//                           : ""
//                   }
//                   alt=""
//                 />
//               </Link>
//             </div>
//             <div className="tile-content">
//               <Link
//                 to={{
//                   pathname: buildCourseDetailsURI(
//                     post.category,
//                     post.CourseName,
//                     post.ID
//                   ),
//                 }}
//               >
//                 <div className="tile-header">
//                   <div className="tile-heading"> {post.CourseName}</div>
//                 </div>
//                 <div className="auth-title">{post.instructorName}</div>

//                 <div className="container-wrap">
//                   <RenderRating ratings={Number(post.rating)} />
//                   <div className="price-wrapper">
//                     <span
//                       className="price"
//                       style={post.isPurchased ? { opacity: "0.5" } : null}
//                     >
//                       {post.EnrollmentFee !== null
//                         ? `${post.EnrollmentFee}   `
//                         : null}
//                     </span>
//                   </div>
//                 </div>
//               </Link>

//               <div className="button-wrapper">
//                 <div className="">
//                   <Link
//                     to={{
//                       pathname: buildCourseDetailsURI(
//                         post.category,
//                         post.CourseName,
//                         post.ID
//                       ),
//                     }}
//                   >
//                     <span>{t("moreInfo")}</span>
//                   </Link>
//                 </div>
//                 {!post.isExperienced && (
//                   <div>
//                     <CartButton post={post} />
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </Tippy>
//     </>
//   );
// };

// export default CourseTile;
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  buildCourseDetailsURI,
  buildCourseModalsURI,
} from "../../../_helpers/utilities";
import RenderRating from "../../Other/StarRating/RenderRating";
import { getS3URL } from "../../../_helpers/utilities";
import CartButton from "./CartButton/CartButton";
import { deleteWishlist, addWishlist } from "../../../_actions/cart.actions";
import { courseActions } from "../../../_actions";
import CourseModal from "./CourseModal";
import "tippy.js/themes/light.css";
import "tippy.js/dist/tippy.css";
import Tippy from "@tippyjs/react";
import moment from "moment/moment";
import "./ToolTip.scss";
import { set } from "date-fns";

const CourseTile = ({
  post,
  bundle,
  demo,
  hidedata,
  viewType,
  activeTab,
  onClickTabItem,
}) => {
  console.log("post", post);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedIn } = useSelector((state) => state.authentication);
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);

  const likeHandler = (courseId, isWishlisted) => {
    if (loggedIn && isWishlisted) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(deleteWishlist(courseId));
    } else if (loggedIn && !isWishlisted) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(addWishlist(courseId));
    } 
    else {
      navigate("/login");
    }
  };

  const handleModal = () => {
    setModal(true);
  };

  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return (() => {
      window.removeEventListener("resize", updateDimension);
    });
  }, [screenSize]);

  return (
    <>
      {/* <Tippy
        theme="light"
        className="tippy"
        interactive={true}
        flipBehavior="flip"
        disabled={viewType === "list" ? false : screenSize.width < 525 ? true : false}
        placement="right"
        content={
          <div className="tippy-content">
            <div className="tippy-coursename">
              {post.CourseName || post.name}
            </div>
            <div className="topspace">
              <p className="updated-date">
                <div className="courseSellingStatus">Bestseller</div>
                <span> Updated:-</span>
                {!bundle
                  ? moment(post?.CreatedOn).format("MMM DD, YYYY")
                  : moment(post?.createdAt).format("MMM DD, YYYY")}
              </p>
            </div>
            <div className="topspace">
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>
                  InstructorName :-
                </span>{" "}
                {post?.instructorName}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Duration:-
                </span>
                {post.Duration || post.duration} Hours
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Language:-
                </span>
                {post.Language || " "}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Level:-
                </span>
                {post.Level || " "}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Price:-
                </span>
                ${post.EnrollmentFee || post.price}
              </div>

              <div className="oneliner">
                {bundle ? (
                  <div
                    dangerouslySetInnerHTML={
                      post.Description
                        ? {
                          __html:
                            post.Description
                              .replace(/<img .*?>/g, "")
                              .substring(0, 300) + "...",
                        }
                        : {
                          __html: post.Description,
                        }
                    }
                  ></div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={
                      post.Description
                        ? {
                          __html:
                            post.Description.replace(
                              /<img .*?>/g,
                              ""
                            ).substring(0, 300) + "...",
                        }
                        : {
                          __html: post.Description,
                        }
                    }
                  ></div>
                )}
              </div>
            </div>
            <div className="navigationPreview">
              <Link
                to={
                  !bundle
                    ? buildCourseDetailsURI(
                      post.category,
                      post.CourseName,
                      post.ID
                    )
                    : buildCourseDetailsURI("", post.name, post.id, post.id)
                }
                className="btn-edit-content startCourse"
              >
                More Info
              </Link>
            </div>
          </div>
        }
      > */}
        {bundle ? (
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 mb-4"
            key={demo ? post : post.id ? post.id.toString() : post.ID.toString()}>
            {/* Header with course title and status */}
            <div className="bg-blue-600 px-4 py-3 rounded-t-lg flex justify-between items-center">
              <h2 className="text-white font-semibold text-lg truncate">
                {post?.name}
              </h2>
              <span className="bg-white text-blue-600 px-3 py-1 rounded text-sm font-medium">
                Published
              </span>
            </div>

            {/* Main content area */}
            <div className="flex">
              {/* Left side - Image */}
              <div className="w-64 h-32 flex-shrink-0">
                {demo ? (
                  <img
                    src={post?.imageLink}
                    alt="Course"
                    className="w-full h-full object-cover rounded-bl-lg"
                     loading="lazy"
                  />
                ) : (
                  <Link
                    aria-label="Course Details"
                    to={buildCourseDetailsURI("", post.name, post.ID, post.ID)}
                  >
                    <img
                      src={post?.imageLink ? getS3URL(post.imageLink) : ""}
                      alt="Course"
                       loading="lazy"
                      className="w-full h-full object-cover rounded-bl-lg hover:opacity-90 transition-opacity"
                    />
                  </Link>
                )}
              </div>

              {/* Right side - Content */}
              <div className="flex-1 p-4">
                <div className="mb-3">
                  <p className="text-sm text-gray-600 mb-2">
                    <span className="font-medium">Category:</span>
                    <span className="text-blue-600 ml-1">Bundle Package</span>
                  </p>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    This bundle package provides comprehensive learning materials and resources for advanced skill development...
                  </p>
                </div>

                {/* Stats section */}
                <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-100">
                  <div className="flex space-x-8 text-sm">
                    <div className="text-center">
                      <div className="text-gray-500 mb-1">No. of Views</div>
                      <div className="text-blue-600 font-semibold">-</div>
                    </div>
                    <div className="text-center">
                      <div className="text-gray-500 mb-1">No. of Enrollments</div>
                      <div className="text-blue-600 font-semibold">-</div>
                    </div>
                    <div className="text-center">
                      <div className="text-gray-500 mb-1">Course Fees</div>
                      <div className="text-blue-600 font-semibold">
                        {post.price !== null ? `$${post.price}` : '$0.00'}
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="text-gray-500 mb-1">Created On</div>
                      <div className="text-blue-600 font-semibold">
                        {moment(post?.createdAt).format("MMM DD, YYYY")}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action buttons */}
                <div className="flex items-center justify-between mt-4">
                  <div className="flex items-center space-x-3">
                    <RenderRating ratings={Number(0)} />
                  </div>
                  <div className="flex items-center space-x-3">
                    <Link
                      to={
                        demo
                          ? ""
                          : buildCourseDetailsURI("", post.name, post.ID, post.ID)
                      }
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium border border-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition-colors"
                    >
                      {t("moreInfo")}
                    </Link>
                    <div>
                      <CartButton post={{ ...post, ID: post.ID }} bundle={bundle} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 mb-4 mx-4"
            key={post.ID.toString()}>
            {/* Header with course title and status */}
            <div className="bg-blue-600 px-4 py-3 rounded-t-lg flex justify-between items-center">
              <h2 className="text-white font-semibold text-lg truncate">
                {post.CourseName}
              </h2>
              <div className="flex items-center space-x-2">
                <RenderRating ratings={Number(post.rating)} />
                {loggedIn && <div
                  className="icon-wrapper"
                  onClick={() => likeHandler(post.ID, post?.isWishlisted)}
                >
                  <span
                    className={`icon ${!post?.isWishlisted ? "icon-like" : "icon-liked"
                      } `}
                  ></span>
                </div>}
              </div>

            </div>

            {/* Main content area */}
            <div className="flex">
              {/* Left side - Image */}
              <div className="w-64 h-32 flex-shrink-0 relative">

                <Link
                  to={{
                    pathname: buildCourseDetailsURI(
                      post.category,
                      post.CourseName,
                      post.ID
                    ),
                  }}
                >
                  <img
                    src={
                      post?.imageFiles?.length > 0
                        ? getS3URL(post?.imageFiles[0]?.fileName)
                        : post?.imageFiles
                          ? getS3URL(post?.imageFiles?.fileName)
                          : post.fileName
                            ? getS3URL(post?.fileName)
                            : ""
                    }
                    alt="Course"
                     loading="lazy"
                    className="w-full h-full object-cover rounded-lg hover:opacity-90 transition-opacity mt-6"
                  />
                </Link>
              </div>

              {/* Right side - Content */}
              <div className="flex-1 p-4">
                <Link
                  to={{
                    pathname: buildCourseDetailsURI(
                      post.category,
                      post.CourseName,
                      post.ID
                    ),
                  }}
                  className="block mb-3 hover:text-blue-600 transition-colors"
                >
                  <div className="mb-2">
                    <p className="text-sm text-gray-600 mb-1">
                      <span className="font-medium">Category:</span>
                      <span className="text-blue-600 ml-1">{post.category || "Software Development"}</span>
                    </p>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {post.Description
                        ? post.Description.replace(/<img .*?>/g, "").substring(0, 300) + "..."
                        : "This course provides comprehensive learning materials and resources for advanced skill development..."}
                    </p>
                  </div>
                </Link>

                {/* Stats section */}
                <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-100 mx-6">
                  <div className="text-center">
                    <div className="text-gray-500 mb-1">No. of Views</div>
                    <div className="text-blue-600 font-semibold">{post.courseViews || 5}</div>
                  </div>
                  <div className="text-center">
                    <div className="text-gray-500 mb-1">No. of Enrollments</div>
                    <div className="text-blue-600 font-semibold">{post.enrollments || 0}</div>
                  </div>
                  <div className="text-center">
                    <div className="text-gray-500 mb-1">Course Fees</div>
                    <div className="text-blue-600 font-semibold">
                      {post.EnrollmentFee !== null ? `$${post.EnrollmentFee}` : '$0.00'}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-gray-500 mb-1">Created On</div>
                    <div className="text-blue-600 font-semibold">
                      {moment(post?.CreatedOn).format("MMM DD, YYYY")}
                    </div>
                  </div>

                </div>

                {/* Action buttons */}
                <div className="flex items-center justify-between mt-4">
                  <div className="flex items-center space-x-3">

                  </div>
                  <div className="flex items-center space-x-3">
                    <Link
                      to={{
                        pathname: buildCourseDetailsURI(
                          post.category,
                          post.CourseName,
                          post.ID
                        ),
                      }}
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium border border-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition-colors"
                    >
                      {t("moreInfo")}
                    </Link>
                    {!post.isExperienced && (
                      <div>
                        <CartButton post={post} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      {/* </Tippy> */}
    </>
  );
};

export default CourseTile;  